import { PermanentTopBannerType } from '../../../models/graphql-types/net';

export const MY_PAGES_REGEX = /^\/([A-Za-z]{2}\/)?mypages(\/.*|\?.*)?$/;
export const CHECKOUT_REGEX = /^\/([A-Za-z]{2}\/)?shopping\/basket(\/.*|\?.*)?$/;
export const QUERY_PARAM = 'store';

export const getTopAreaBannerType = (
  pathname: string | null,
  isAnonymousWithStore?: boolean,
): PermanentTopBannerType | null => {
  if (pathname === null) {
    return null;
  }
  if (MY_PAGES_REGEX.test(pathname)) {
    return PermanentTopBannerType.MyPages;
  }

  if (CHECKOUT_REGEX.test(pathname)) {
    return PermanentTopBannerType.Checkout;
  }

  if (isAnonymousWithStore) {
    return PermanentTopBannerType.PublicPageWithReferral;
  }

  return PermanentTopBannerType.PublicPage;
};
